import { render, staticRenderFns } from "./shopmode.vue?vue&type=template&id=6ed797b9&scoped=true"
import script from "./shopmode.vue?vue&type=script&lang=ts"
export * from "./shopmode.vue?vue&type=script&lang=ts"
import style0 from "./shopmode.vue?vue&type=style&index=0&id=6ed797b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed797b9",
  null
  
)

export default component.exports